<template>
  <div style="display: flex;align-items: center;">
    <div style="flex: 1;">
      <el-tabs v-model="localActiveTab" v-if="energyTypes.length > 1" @tab-click="handleTabClick">
        <el-tab-pane v-for="energyType in energyTypes" :label="getEnergyName(energyType)"
          :name="energyType.toString()" :key="energyType"></el-tab-pane>
      </el-tabs>
    </div>
    <div style="display: flex;align-items: center;">
      <el-radio-group v-model="localActiveDateTab" size="mini" style="margin-right: 8px;" @change="handleDateTabChange">
        <el-radio-button :label="1">{{ $t('龙翼简报.日') }}</el-radio-button>
        <el-radio-button :label="2">{{ $t('龙翼简报.月') }}</el-radio-button>
      </el-radio-group>
      <el-date-picker size="mini" style="width: 150px;" v-show="localActiveDateTab == 1" v-model="localQueryDay"
        type="date" :picker-options="datePickerOptions" :placeholder="$t('龙翼简报.选择日期')" @change="handleDayChange">
      </el-date-picker>
      <el-date-picker size="mini" style="width: 150px;" v-show="localActiveDateTab == 2"
        v-model="localQueryMonth" type="month" :picker-options="monthPickerOptions"
        :placeholder="$t('龙翼简报.选择月份')" @change="handleMonthChange">
      </el-date-picker>
    </div>
  </div>
</template>
<script>
import settings from "@/settings";
export default {
  name: "DashboardHeader",
  props: {
    activeTab: {
      type: String,
      default: "3"
    },
    activeDateTab: {
      type: Number,
      default: 1
    },
    queryDay: {
      type: String,
      default: ""
    },
    queryMonth: {
      type: String,
      default: ""
    },
    energyTypes: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      localActiveTab: this.activeTab,
      localActiveDateTab: this.activeDateTab,
      localQueryDay: this.queryDay,
      localQueryMonth: this.queryMonth,
      datePickerOptions: {
        disabledDate(date) {
          if (settings.supportTodayDataQuery) {
            return date > new Date(new Date().getTime())
          }
          return date > new Date(new Date().getTime() - 24 * 60 * 60 * 1000)
        }
      },
      monthPickerOptions: {
        disabledDate(date) {
          var t = new Date();
          var n = new Date(t.getFullYear(), t.getMonth(), 1);
          if (settings.supportTodayDataQuery) {
            return date > new Date(new Date().getTime())
          }
          return date > new Date(n.getTime() - 24 * 60 * 60 * 1000)
        }
      }
    };
  },
  watch: {
    activeTab: {
      handler(newVal) {
        this.localActiveTab = newVal;
      },
      immediate: true
    },
    activeDateTab: {
      handler(newVal) {
        this.localActiveDateTab = newVal;
      },
      immediate: true
    },
    queryDay: {
      handler(newVal) {
        this.localQueryDay = newVal;
      },
      immediate: true
    },
    queryMonth: {
      handler(newVal) {
        this.localQueryMonth = newVal;
      },
      immediate: true
    }
  },
  methods: {
    getEnergyName(energyType) {
      if (energyType == 1) {
        return this.$t('oiltype.caiyouji');
      } else if (energyType == 2) {
        return this.$t('oiltype.qitiji');
      } else if (energyType == 3) {
        return this.$t('oiltype.youdain');
      } else if (energyType == 4) {
        return this.$t('oiltype.qidian');
      } else if (energyType == 5) {
        return this.$t('oiltype.chundiandong');
      } else if (energyType == 6) {
        return this.$t('oiltype.ranliao');
      }
      return '';
    },
    handleTabClick() {
      this.$emit('update:activeTab', this.localActiveTab);
    },
    handleDateTabChange() {
      this.$emit('update:activeDateTab', this.localActiveDateTab);
    },
    handleDayChange() {
      this.$emit('update:queryDay', this.localQueryDay);
    },
    handleMonthChange() {
      this.$emit('update:queryMonth', this.localQueryMonth);
    }
  }
};
</script>